// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1VDK1","title":"AfterFrontImage_title__2JfOp"};